<template>
  <div class="modal-pdv modal-full modal-gestor" :class="{'show': modal}">
    <div class="modal-pdv-content" v-show="modal">
      <div v-if="tipoExibicao === 1">
        <container-pedidos @fecharModal="modal = false" modal="true"/>
      </div>
      <div v-if="tipoExibicao === 2">
        <kanban-pedidos @fecharModal="modal = false" modal="true"/>
      </div>
    </div>
  </div>
</template>

<script>
  import ContainerPedidos from "@/components/gestor/ContainerPedidos";
  import KanbanPedidos from "@/components/gestor/KanbanPedidos";
  export default {
    name: "ListaLecard",
    components: {KanbanPedidos, ContainerPedidos},
    data() {
      return {
        modal: false,
        tipoExibicao: null
      }
    },

    mounted() {
      this.tipoExibicao = localStorage.getItem('modoLista') === '1' ? 1 : 2;
    },

    methods: {
      openListaLecard() {
        this.$emit('abrirPedidos');
        this.modal = true;
      }
    }
  }
</script>
<style scoped>
 .modal-gestor {
   z-index: 1090;
 }

 .modal-pdv .modal-pdv-content {
   padding: 15px 0 0;
 }
</style>
